import { JSX } from "react";

export function ErrorContent(): JSX.Element {
    return (
        <>
             <h1>404</h1>
             <p>The page you are looking for does not exist.</p>
        </>
    );
}